import type { LucideIcon } from 'lucide-react'

/** Line icons at the design system's stroke. One place, one size. */
export function Icon({ of: Of, size = 17 }: { of: LucideIcon; size?: number }) {
  return <Of size={size} strokeWidth={1.8} aria-hidden="true" />
}
